import type { TFunction } from "i18next";

export type RoutingUsageError = {
  errorCode?: string;
  scope?: "workspace" | "service";
  resetAt?: string;
};

/** Handles both HTTP failures and per-driver errors in a partial ETA response. */
export const routingUsageMessage = (
  error: unknown,
  t: TFunction,
  language = "en",
): string | undefined => {
  const payload = ((error as { response?: { data?: RoutingUsageError } })
    ?.response?.data ?? error) as RoutingUsageError | undefined;
  if (payload?.errorCode === "ROUTING_USAGE_UNAVAILABLE")
    return t("common:routing_usage_unavailable");
  if (payload?.errorCode !== "ROUTING_QUOTA_EXCEEDED") return undefined;
  const reset = payload.resetAt ? new Date(payload.resetAt) : null;
  const resetAt =
    reset && !Number.isNaN(reset.getTime())
      ? reset.toLocaleString(language === "no" ? "nb-NO" : language, {
          timeZone: "Europe/Oslo",
          dateStyle: "short",
          timeStyle: "short",
        })
      : t("common:routing_quota_next_day");
  return t(
    payload.scope === "service"
      ? "common:routing_quota_service"
      : "common:routing_quota_workspace",
    { resetAt },
  );
};
